import React, { useState, useEffect } from 'react';
import { FormattedMessage } from "react-intl"
import { useNavigate, Link, Form } from "react-router-dom";
import axios from 'axios';
import BaseInput from '../components/UI/BaseInput'
import { ThreeDots } from 'react-loader-spinner';
import Subtitle from '../components/UI/Subtitle';


const VerificationCode = () => {

    const [verificationToken, setVerificationToken] = useState("")
    const [wrongToken, setWrongToken] = useState("")
    const [resetToken, setResetToken] = useState("")
    const [authenticated, setAuthenticated] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [notMatching, setNotMatching] = useState(false)
    const [isWeakPassword, setIsWeakPassword] = useState(false)
    const [passwordUpdated, setPasswordUpdated] = useState(false)
    const [redirecting, setRedirecting] = useState(false)
    const [showPassword, setShowPassword] = useState(false);

    let labelTextStyle = 'text-l text-green-900 text-center'


    const navigate = useNavigate();

    useEffect(() => {
        setIsWeakPassword(false)
        setNotMatching(false)
        setVerificationToken("")
    }, [authenticated, wrongToken])


    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        const headers = { headers: {} };
        if (newPassword !== confirmPassword) {
            setNotMatching(true)
            return
        }
        if (resetToken !== '' && (newPassword === confirmPassword)) {
            formData.append('new_password', newPassword)
            formData.append('reset_token', resetToken)
            try {
                const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/users/password/reset/change`, formData, headers)
                data.then(res => {
                    if (res?.data?.status === "ok") {
                        setPasswordUpdated(true)
                        setRedirecting(true)
                        setTimeout(() => {
                            navigate('/app/login')
                        }, 5000);
                    } else if (res?.data?.status === "ko") {
                        if (res?.data['error']['validation']['field'] === "password") {
                            setIsWeakPassword(true)
                        } else {
                            //console.log(res.data);
                        }
                    }
                })
            } catch (err) {
                //console.log(err);
            }
        } else {
            formData.append('verification_code', verificationToken.toLowerCase())
            try {
                const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/users/password/reset/verify`, formData, headers)
                data.then(res => {
                    if (res?.data[0]?.status === "ok") {
                        setResetToken(res?.data[0].reset_token)
                        setAuthenticated(true)
                    } else if (res?.data.status === "ko") {
                        setWrongToken(true)
                    }
                })
            } catch (err) {
                //console.log(err);
            }
        }
    }

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <div className="p-4 flex flex-col items-center mt-28">
                {authenticated ? (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4" style={{ minWidth: '400px' }}>
                        <Subtitle>
                            <FormattedMessage id="app.recover.enterNewPassword" defaultMessage="New password" />
                        </Subtitle>

                        <div className={labelTextStyle}>
                            <FormattedMessage id="app.register.formik.passwordRegex" defaultMessage=""  />
                        </div>

                        <p>Password</p>
                        <div class="relative">
                            <BaseInput className="w-full block" type={showPassword ? "text" : "password"} value={newPassword}
                                onChange={(e) => setNewPassword(e.currentTarget.value)}
                            />
                            <div onClick={handleShowPassword} className="cursor-pointer absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                                <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}></i>
                            </div>
                        </div>



                        <p><FormattedMessage id="app.recover.confirmPassword" defaultMessage="Confirm Password" /></p>

                        <div className="relative">
                            <BaseInput
                                className="w-full block"
                                type={showPassword ? "text" : "password"} value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.currentTarget.value)}
                            />
                            <div onClick={handleShowPassword} className="cursor-pointer absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                                <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}></i>
                            </div>
                        </div>

                        <button className='w-full inline-block bg-blue-900 text-center text-white font-medium rounded-xl p-2' type='submit'>
                            Reset
                        </button>
                        {isWeakPassword && <div className='text-red-500 text-sm	'><FormattedMessage id="app.recover.weakPassword" defaultMessage="Weak password" /></div>}
                        {passwordUpdated && <div><FormattedMessage id="app.recover.updatedPassword" defaultMessage="Password updated, you can now login" /></div>}
                        {notMatching && <div className='text-red-500 text-sm'><FormattedMessage id="app.recover.notMatching" defaultMessage="Passwords are not matching" /></div>}
                        {redirecting && <div className="col-span-6 mt-12 flex justify-center items-center">
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2f4d44"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div>}
                    </form>
                ) : (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4" style={{ minWidth: '400px' }}>
                        <Subtitle><FormattedMessage id="app.recover.enterToken" defaultMessage="Enter verification token" /></Subtitle>
                        <BaseInput value={verificationToken}
                            onChange={(e) => setVerificationToken(e.currentTarget.value)}
                        />
                        <button className='w-full inline-block bg-blue-900 text-center text-white font-medium rounded-xl p-2' type='submit'>
                            <FormattedMessage id="app.recover.authenticate" defaultMessage="Authenticate" />
                        </button>
                        {wrongToken &&
                            <p className='text-sm text-red-500'>
                                <FormattedMessage id="app.recover.expiredOrWrong" defaultMessage="Expired or wrong reset token." />
                            </p>}
                    </form>
                )
                }
            </div>
        </>
    )
}

export default VerificationCode


